import {
  resolveFeatureAppUrl,
  type FeatureAppKey,
  type FeatureAppUrlEntry,
} from '@kawai/shared';

/**
 * Phase 5 (S-03): tenant-portal の HomePage で表示する機能カードの遷移先 URL。
 *
 * A-37: URL map の実体は `@kawai/shared` の `featureAppUrls.ts` に昇格（各管理アプリの
 * ヘッダー相互リンクと単一の真実源を共有するため）。本モジュールは互換のための薄い
 * ラッパで、従来の公開 API（`getFeatureUrlEntry` / `getFeatureUrl` / `isFeatureReady` /
 * `TenantPortalLinkKey`）を維持する。
 */

export type TenantPortalLinkKey = FeatureAppKey;

/** 純関数として export（test 用に mode を直接渡せる） */
export function getFeatureUrlEntry(
  key: TenantPortalLinkKey,
  mode: string,
): FeatureAppUrlEntry {
  return resolveFeatureAppUrl(key, mode);
}

/** ランタイム用 shortcut。`import.meta.env.MODE` を読む */
export function getFeatureUrl(key: TenantPortalLinkKey): string {
  return resolveFeatureAppUrl(key, import.meta.env.MODE).url;
}

export function isFeatureReady(key: TenantPortalLinkKey): boolean {
  return resolveFeatureAppUrl(key, import.meta.env.MODE).ready;
}
